import GLightbox from "glightbox/src/js/glightbox";
import { Collapse } from "bootstrap";

//(S)css Imports
import "../Scss/custom.scss";
import "glightbox/dist/css/glightbox.css";

document.addEventListener("DOMContentLoaded", function() {


    GLightbox({
        touchNavigation: true,
        loop: true
    });

});